var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, css, html, property, LitElement, state } from 'lit-element';
let TcCustomSelect = class TcCustomSelect extends LitElement {
    constructor() {
        super(...arguments);
        this.name = '';
        this.selectOpen = false;
        this.selectedValue = '';
        this.selectedOption = '';
    }
    clickOutside(event) {
        const target = event.target;
        if (target.closest('tc-custom-select') === null) {
            this.selectOpen = false;
        }
    }
    firstUpdated() {
        document.addEventListener('click', this.clickOutside.bind(this));
        this._slottedChildren.forEach((child) => {
            child.addEventListener('change', (event) => {
                event.stopPropagation();
                this.selectOpen = false;
                this.deselectRest(child);
                this.setSelected(child);
                // Emitujemy event change
                this.dispatchEvent(new CustomEvent('tc-selected-option', {
                    detail: child,
                    bubbles: true,
                }));
            });
        });
        const selectedChild = this.getSelectedChild();
        if (selectedChild) {
            this.setSelected(selectedChild);
        }
        else {
            this.selectFirstOption();
        }
    }
    setSelected(element) {
        this.selectedValue = element.getAttribute('value') || '';
        this.selectedOption = element.getAttribute('name') || '';
    }
    getSelectedChild() {
        return this._slottedChildren.find((child) => {
            // Check if the child is selected
            if (child.hasAttribute('selected')) {
                return child;
            }
            return null;
        });
    }
    selectFirstOption() {
        const firstOption = this._slottedChildren[0];
        if (firstOption) {
            this.setSelected(firstOption);
        }
    }
    deselectRest(selectedChild) {
        this._slottedChildren.forEach((child) => {
            if (selectedChild.getAttribute('value') === child.getAttribute('value')) {
                return;
            }
            // Odznaczamy radio buttony w komponencie
            const shadowRoot = child.shadowRoot;
            if (!shadowRoot) {
                return;
            }
            const radio = shadowRoot.querySelector('input[type="radio"]');
            if (radio) {
                radio.checked = false;
            }
        });
    }
    toggle(event) {
        event.preventDefault();
        this.selectOpen = !this.selectOpen;
    }
    get _slottedChildren() {
        const shadowRoot = this.shadowRoot;
        if (!shadowRoot) {
            return [];
        }
        const slot = shadowRoot.querySelector('slot');
        if (!slot) {
            return [];
        }
        return slot.assignedElements({ flatten: true });
    }
    static get styles() {
        return css `
            * {
                box-sizing: border-box;
            }

            .custom-select {
                position: relative;
                width: auto;
                max-width: 100%;
                font-size: 1rem;
                color: #000;
                z-index: 10;
                font-family: Montserrat, sans-serif;
            }

            .select-button {
                width: 100%;
                font-size: 1rem;
                background-color: #fff;
                padding: 0.5rem 2.5rem 0.5rem 0.5rem;
                border: none;
                border-radius: 0.25rem;
                cursor: pointer;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                font-family: Montserrat, sans-serif;
            }

            .select-button::after {
                color: #000;
                border-style: solid;
                border-width: 0.17em 0.17em 0 0;
                content: '';
                display: inline-block;
                height: 0.65em;
                right: 10px;
                position: absolute;
                top: 7px;
                transform: rotate(135deg);
                vertical-align: top;
                width: 0.65em;
                transition: all 0.3s;
            }

            .custom-select.active .select-button::after {
                transform: rotate(-45deg);
                top: 12px;
            }

            .selected-value {
                text-align: left;
                text-transform: uppercase;
                font-weight: 600;
                color: #000;
            }

            .select-dropdown {
                position: absolute;
                list-style: none;
                width: 100%;
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.11);
                background-color: #fff;
                border-radius: 8px;
                padding: 0.5rem 1.5rem 0.5rem 1.5rem;
                margin-top: 0;
                max-height: 300px;
                overflow-y: auto;
                transition: 0.2s ease-in;
                transform-origin: top;
                transform: translateY(-20px);
                opacity: 0;
                visibility: hidden;
                min-width: 275px;
                right: 0;
            }

            .select-dropdown:focus-within {
                box-shadow: 0 10px 25px rgba(94, 108, 233, 0.6);
            }

            .select-dropdown::-webkit-scrollbar {
                width: 7px;
            }
            .select-dropdown::-webkit-scrollbar-track {
                background: #f1f1f1;
                border-radius: 25px;
            }

            .select-dropdown::-webkit-scrollbar-thumb {
                background: #ccc;
                border-radius: 25px;
            }

            .custom-select.active .select-dropdown {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
            }
        `;
    }
    render() {
        return html `
            <div class="custom-select ${this.selectOpen ? 'active' : ''}">
                <input type="hidden" name="${this.name}" value="${this.selectedValue}" />
                <button
                    class="select-button"
                    role="combobox"
                    aria-labelledby="select button"
                    aria-haspopup="listbox"
                    aria-expanded="false"
                    aria-controls="select-dropdown"
                    @click="${this.toggle}"
                >
                    <span class="selected-value">${this.selectedOption}</span>
                </button>
                <div class="select-dropdown" role="listbox" id="select-dropdown">
                    <slot></slot>
                </div>
            </div>
        `;
    }
};
__decorate([
    property({ type: String })
], TcCustomSelect.prototype, "name", void 0);
__decorate([
    state()
], TcCustomSelect.prototype, "selectOpen", void 0);
__decorate([
    state()
], TcCustomSelect.prototype, "selectedValue", void 0);
__decorate([
    state()
], TcCustomSelect.prototype, "selectedOption", void 0);
TcCustomSelect = __decorate([
    customElement('tc-custom-select')
], TcCustomSelect);
export default TcCustomSelect;
